<div class="main-content">
  <div class="main-heading">
    <span class="page-actions text-right"> </span>
  </div>
  <div class="card">
    <div class="card-body">
      <div class="table-view mbtm-30">
        <!-- Table starts -->
        <p-table
          #dt
          [value]="foodSafetylist"
          [rows]="10"
          [paginator]="true"
          [pageLinks]="3"
          [rowsPerPageOptions]="[5, 10, 20]"
          [showCurrentPageReport]="true"
          currentPageReportTemplate="{{ 'SUMMARY_TOTALRECORDS' | translate }}"
        >
          <!-- Caption -->
          <ng-template pTemplate="caption">
            <div class="ui-helper-clearfix">
              <div class="table-options">
                <div class="pull-right">
                  <kuba-export
                    [reportData]="dt.filteredValue || dt.value"
                    [additionalData]="additionalData"
                  ></kuba-export>
                </div>
              </div>
            </div>
          </ng-template>
          <!-- Header -->
          <ng-template pTemplate="header">
            <tr>
              <th pSortableColumn="ZoneName">
                {{ "ZONE_NAME" | translate }}
                <p-sortIcon field="ZoneName"></p-sortIcon>
              </th>
              <th width="140px">{{ "ASSIGNED_ACCESS" | translate }}</th>
              <th width="160px">{{ "DEVIATIONS_IN_FOLLOWUP" | translate }}</th>
              <th *ngIf="isAdministrateFs">{{ "OPTIONS" | translate }}</th>
            </tr>
            <tr>
              <th>
                <input
                  pInputText
                  type="text"
                  (input)="
                    dt.filter(
                      $any($event.target)?.value,
                      'ZoneName',
                      'contains'
                    )
                  "
                  placeholder=""
                  class="p-column-filter"
                />
              </th>
              <th></th>
              <th></th>
              <th *ngIf="isAdministrateFs"></th>
            </tr>
          </ng-template>
          <!-- Body Content -->
          <ng-template pTemplate="body" let-fs>
            <tr>
              <td>
                <a
                  [routerLink]="['./../../details', fs.Id]"
                  [queryParams]="{ Title: fs.ZoneName }"
                  >{{ fs.ZoneName }}</a
                >
              </td>
              <td>
                <button
                  type="button"
                  class="btn btn-link"
                  title="{{ 'View users' | translate }}"
                  (click)="showAssignedUsers(fs.FoodSafetyUsers)"
                >
                  <span>{{ fs.UserCount !== null ? fs.UserCount : "" }}</span>
                </button>
              </td>
              <td>
                <input
                  type="checkbox"
                  [disabled]="true"
                  [(ngModel)]="fs.ShowDeviation"
                />
              </td>
              <td class="col-button" *ngIf="isAdministrateFs">
                <a
                  [routerLink]="['./../../edit', fs.Id]"
                  
                  title="{{ 'EDIT' | translate }}" [attr.aria-label]="'EDIT' | translate" class="kuba-icon-btn kuba-icon-btn--ghost kuba-icon-btn--row"><i class="pi pi-pencil"></i></a>
                <button
                  type="button"
                  (click)="deleteZoneDialog(fs['Id'])"
                  title="{{ 'DELETE' | translate }}"
            [attr.aria-label]="'DELETE' | translate" class="kuba-icon-btn kuba-icon-btn--danger kuba-icon-btn--row">
            <i class="pi pi-trash"></i>
          </button>
              </td>
            </tr>
          </ng-template>
          <!-- Empty message -->
          <ng-template pTemplate="emptymessage" let-columns>
            <tr>
              <td colspan="4">
                {{ "NO_RECORDS_FOUND" | translate }}
              </td>
            </tr>
          </ng-template>
        </p-table>
        <!-- Table Ends -->
      </div>
    </div>
  </div>
  <router-outlet></router-outlet>
  <p-dialog
    header="{{ 'DELETE_CONFORMATION' | translate }}"
    [(visible)]="deleteDialog"
    [modal]="true"
    [style]="{ width: '300px' }"
    [resizable]="false"
    [draggable]="false"
  >
    <div>
      <div class="form-group">
        <label for="RepeatPassword">
          <span translate>Please_type_DELETE</span>
          <span class="required">*</span>
        </label>
        <div>
          <input
            type="text"
            pInputText
            [(ngModel)]="delete"
            (keyup)="onDelete(delete)"
          />
        </div>
      </div>
    </div>

    <button type="button" class="btn btn-primary" (click)="closeZoneDialog()">
      <span translate>No</span>
    </button>
    <button
      type="button"
      class="btn btn-primary"
      [disabled]="!deleteButton"
      (click)="deleteFoodSafety(deleteZoneID)"
    >
      <span translate>DELETE</span>
    </button>
  </p-dialog>

  <p-confirmDialog
    header="{{ 'CONFIRMATION' | translate }}"
    icon="pi pi-question-circle"
    width="425"
    acceptLabel="{{ 'SWITCH_YES' | translate }}"
    rejectLabel="{{ 'SWITCH_NO' | translate }}"
  ></p-confirmDialog>

  <p-dialog
    header="{{ 'ASSIGNED_ACCESS' | translate }}"
    [(visible)]="showDialog"
    [modal]="true"
    [style]="{ width: '300px' }"
    [resizable]="false"
    [draggable]="false"
    (onHide)="onHide()"
  >
    <div class="table-view">
      <p-table
        #et
        [value]="assignedUsers"
        [rows]="10"
        [paginator]="true"
        [pageLinks]="3"
        [rowsPerPageOptions]="[5, 10, 20]"
      >
        <ng-template pTemplate="header">
          <tr>
            <th>{{ "NAME" | translate }}</th>
          </tr>
          <tr>
            <th>
              <input
                pInputText
                type="text"
                (input)="
                  et.filter($any($event.target)?.value, 'NameList', 'contains')
                "
                placeholder=""
                class="p-column-filter"
              />
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-user>
          <tr>
            <td>
              <span>{{ user.NameList }}</span>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td colspan="1">{{ "NO_RECORDS_FOUND" | translate }}</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </p-dialog>


<kuba-busy [busy]="showLoader" message="PROCESSING"></kuba-busy>

</div>
